export const Container = ({ className, ...props }) => {
  return <div className={`w-11/12 max-w-full text-left ${className}`} {...props} />;
};
